<script setup lang="ts">
import { Alert, ButtonLink } from "@/components/ui"
import { useTranslation } from "@/composables"

const { t } = useTranslation()
</script>

<template>
  <Alert
    compact
    variant="primary-solid"
    sharp-corners
    class="px-0"
    :closable="false"
  >
    <div class="flex flex-row items-center justify-between container mx-auto">
      <div class="flex items-end gap-2 font-comfortaa">
        <h3 class="font-bold">
          {{ t("freemium_banner.title", { brand: "GUESTPIX" }) }}
        </h3>
      </div>

      <ButtonLink
        href="https://guestpix.com/free-photo-sharing-app/?utm_source=web&utm_medium=internal&utm_campaign=guest&utm_content=guestbanner"
        variant="secondary"
        data-test="freemium-cta"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ t("freemium_banner.cta_btn") }}
      </ButtonLink>
    </div>
  </Alert>
</template>
